import React, { Component } from 'react';
import * as Styles from './Styles';
import Switch from '../../../components/switch/Switch';
import ConsentItem from './ConsentItem';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../core/Store';
import * as FormManager from '../../../reducers/ui/form';
import * as DictionariesConsentsSelectors from '../../../reducers/data/dictionaries/consents/selectors';
import HoverPopover, { POSITION } from '@react_components/hover_popover';

type State = {};

class ConsentsComponent extends Component<PropsFromRedux, State> {
	state: State = {};

	render() {
		return (
			<Styles.Wrapper id="form-stage2-consents">
				<Styles.Background>
					<Styles.HeadingTopFontContainer>
						{this.props.error && (
							<HoverPopover
								content={<span>{this.props.error}</span>}
								position={POSITION.TOP}
							>
								<Styles.StyledSvgInfo />
							</HoverPopover>
						)}
						<Styles.TopHeadingFont>
							Oświadczenie oraz zgody
						</Styles.TopHeadingFont>
					</Styles.HeadingTopFontContainer>
					<Styles.BottomHeadingFont>
						Oświadczenia oznaczone gwiazdką (<span>*</span>) są
						obowiązkowe
					</Styles.BottomHeadingFont>
					<Styles.ConsentsContainer>
						<Styles.ConsentsHeadingContainer>
							<Switch
								isActive={
									this.props.allRequiredStage2ConsentsChecked
								}
								onClick={() =>
									FormManager.toggleAllStep2Consents()
								}
							/>
							<p>
								Zaznacz <strong>wszystkie</strong> zgody i
								oświadczenia
							</p>
						</Styles.ConsentsHeadingContainer>
						<Styles.ConsentsContentContainer>
							{this.props.consents.map((consent) => {
								const cState = this.props.consentsState.find(
									(el) => el.consentId === consent.consentId
								);

								return (
									<ConsentItem
										key={consent.consentId}
										checked={cState?.consentState || false}
										label={consent.consentContent}
										required={consent.consentRequire}
										onClick={() =>
											FormManager.flipConsent(
												consent.consentId,
												'step2'
											)
										}
									/>
								);
							})}
						</Styles.ConsentsContentContainer>
					</Styles.ConsentsContainer>
				</Styles.Background>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		consentsState: FormManager.Selectors.getConsentsStep2(state),
		consents: DictionariesConsentsSelectors.getConsentsStage2(state),
		allRequiredStage2ConsentsChecked:
			FormManager.Selectors.getAllRequiredStage2ConsentsChecked(state),
		error: FormManager.Selectors.getConsentsError(state),
	}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Consents = connector(ConsentsComponent);
export default Consents;
